module.exports = __webpack_public_path__ + "img/01-afghanistan-energy-security.b30b10f1.jpg";